module.exports = __webpack_public_path__ + "img/buen_fin1.7051c5cd.jpg";